module.exports = __webpack_public_path__ + "d5585e09d537d9aff522a9bd1e89e636.svg";